import React, { DetailedHTMLProps, HTMLAttributes, useMemo } from 'react';
import CssHelper from 'Services/Utils/Css/CssHelper';
import Spinner from '../Spinner/Spinner';
import styles from './Button.module.sass';

const Button = ({
    children,
    iconBefore, iconAfter,
    isDisabled, isLoading, isActive,
    variant, color, size, shape,
    onClick,
    ...props
}: Props) => {
    const state = useMemo(() => {
        let output = 'default';
        if (isDisabled) output = 'disabled';
        if (isLoading) output = 'loading';
        if (isActive) output = 'active';
        return output;
    }, [isDisabled, isLoading, isActive]);

    return <div
            onClick={() => !isDisabled ? onClick() : undefined}
            className={CssHelper.createCssClass(`
                ${styles['button']}
                ${!children && iconBefore&& styles['button__icon']}
                ${styles['button__size--'+(size||'medium')]}
                ${styles['button__shape--'+(shape||'rectangle')]}
                ${styles['button__variant--'+(variant||'transparent')]}
                ${styles['button__color--'+(color||'primary')]}
                ${styles['button__state--'+(state||'default')]}
            `)}
            {...props}
        >
        <div className={styles['button__wrapper']}>
            { iconBefore }
            { children }
            { iconAfter }
        </div>
        {
            state === 'loading' &&
            <div className={styles['button__spinner']}>
                <Spinner />
            </div>
        }
    </div>;
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children?: any
    iconBefore?: any
    iconAfter?: any
    isDisabled?: boolean
    isLoading?: boolean
    isActive?: boolean
    onClick?: any
    variant?: 'transparent' | 'solid' | 'border' | 'tab'
    color?: 'primary' | 'secondary' | 'neutral-dark' | 'warning' | 'error' | 'light' | 'dark'
    size?: 'inline' | 'small' | 'medium' | 'large'
    shape?: 'circle' | 'rectangle'
    ref?: any
}

export default React.memo(Button);